// @flow
import React, { useEffect, useRef, useState } from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import {
  getArticleTeaserData,
  ArticleData
} from '@ta-interaktiv/react-article-teasers'
import styles from './articleLink.m.scss'
import {
  getAuthors,
  getCommentCounts,
  getLead,
  getPublishingDate,
  getTeaserImgSrc,
  getTitle,
  getTitleHeader,
  getTotalShareCount,
  getUpdatedDate,
  getUrl,
  isPremium
} from '@ta-interaktiv/api-access'
import { StylesContext } from '@material-ui/styles'
import { cosmiconfig } from 'cosmiconfig'

const publisherDomain = parseHostname().publicationDomain

export function ArticleLink({
  publisherDomain,
  articleId,
  title,
  lead
}: {
  publisherDomain: string
  articleId: string
  title?: string
  lead: string
}) {
  return (
    <a
      href={`https://www.${publisherDomain}/${articleId}`}
      target='_parent'
      className='item'
    >
      <i className='chevron right icon' />
      <div className='content'>
        <div className='header'>{title}</div>
        {lead}
      </div>
    </a>
  )
}

export function ArticleBlock({
  header,
  articleId,
  title,
  lead
}: {
  header: string
  articleId: string
  title?: string
  lead: string
}) {
  return (
    <div className='ui vertical very fitted segment article-block'>
      <div className='ui text container'>
        <h4 className='ui infographic tiny header'>{header}</h4>
        <div className='ui icon very infographic list'>
          <ArticleLink
            publisherDomain={publisherDomain}
            articleId={articleId}
            title={title}
            lead={lead}
          />
        </div>
      </div>
    </div>
  )
}

/**
 * Dynamic inline teaser Function.
 * This function allows to render one or several article teasers.
 *
 * @param {string} title The title displayed on the bloc containing the teasers. "Lire aussi:" is the default value.
 * @param {string[]} ids The list of articles' ids.
 * @param {boolean} inverted Dark mode.
 */
export const ArticleTeaser = ({
  title = 'Lire aussi:',
  ids,
  inverted = false
}: {
  title?: string
  ids: string[]
  inverted?: boolean
}) => {
  const pub = parseHostname().publicationName
  const [articles, setArticles] = useState(
    new Map<string | number, ArticleData>()
  )

  useEffect(() => {
    ids.forEach(id => {
      getArticleTeaserData(pub, id).then((articleTeaserData: ArticleData) => {
        if (articleTeaserData) {
          setArticles(articles => new Map(articles.set(id, articleTeaserData)))
        }
      })
    })
  }, [ids])

  return (
    <>
      {articles.size > 0 && (
        <div
          className={`${styles.container} ${inverted &&
            styles.containerInverted}`}
        >
          <div className={`${styles.bar} ${inverted && styles.barInverted}`} />
          <div
            className={`${styles.header} ${inverted && styles.headerInverted}`}
          >
            {title}
          </div>
          <div className={styles.list}>
            {[...articles.values()].map((article: ArticleData) => (
              <a
                className={styles.teaserContainer}
                key={`article-teaser-${article.id}`}
                href={article.url}
              >
                <div className={styles.imageContainer}>
                  <img className={styles.image} alt='' src={article.imageSrc} />
                </div>
                <div className={styles.content}>
                  <div
                    className={`${styles.articleHeader} ${inverted &&
                      styles.articleHeaderInverted}`}
                  >
                    {article.isPremium && (
                      <span
                        className={`${styles.abo} ${inverted &&
                          styles.aboInverted}`}
                      >
                        ABO
                      </span>
                    )}
                    {article.titleHeader}
                  </div>
                  <div
                    className={`${styles.articleTitle} ${inverted &&
                      styles.articleTitleInverted}`}
                  >
                    {article.title}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
